import { api, clearPartnerGuestSession } from "./api";
import { ACCESS_TOKEN, setCookie, REFRESH_TOKEN } from "../lib/cookie";

export interface SignupPayload {
  username: string;
  password: string;
  name: string;
  englishName: string;
  email: string;
  birthDate: string; // 'YYYY-MM-DD'
  phone: string;
  workplace: string;
  department: string; // 소속과
  position: string; // 직위
  isSpecialist: boolean; // 전문의 여부
  medicalLicenseNumber?: string;
  specialistNumber?: string; // 전문의일 때만
}

export interface ApiResponse<T = unknown> {
  resultCode: string;
  message: string;
  data: T;
  total: number;
}

export interface SignupResult {
  success: boolean;
  status: number;
  code: string;
  message: string;
  data?: ApiResponse<number> | null;
}

//쿠키에 토큰 저장
export const login = async (id: string, pw: string): Promise<boolean> => {
  try {
    const body = { username: id, password: pw };
    const { data } = await api().post("/v1/auth/authenticate", body);
    if (data) {
      setCookie(ACCESS_TOKEN, data.data.accessToken);
      setCookie(REFRESH_TOKEN, data.data.refreshToken);
    }
    return true;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const checkUser = async () => {
  try {
    const { data } = await api().get("/login-user");
    return data.data.role;
  } catch (e) {
    console.log(e);
    return "false";
  }
};

export const checkUserName = async () => {
  try {
    const { data } = await api().get("/login-user");
    return data.data.name;
  } catch (e) {
    console.log(e);
    return "false";
  }
};

// //세션스토리지에 토큰 저장
// export const sessionLogin = async (id: string, pw: string): Promise<boolean> => {
//   try {
//     const body = { username: id, password: pw };
//     const { data } = await api().post("/v1/auth/authenticate", body);
//     if (data) {
//       sessionStorage.setItem(ACCESS_TOKEN, data.data.accessToken);
//     }
//     return true;
//   } catch (e) {
//     console.log(e);
//     return false;
//   }
// };

//로컬스토리지에 토큰 저장
export const localLogin = async (id: string, pw: string): Promise<boolean> => {
  try {
    const body = { username: id, password: pw };
    const { data } = await api().post("/v1/auth/authenticate", body);
    if (data) {
      localStorage.setItem(ACCESS_TOKEN, data.data.accessToken);
      // 협력 사이트 게스트로 보던 중 로그인하면 게스트 세션은 버리고 회원으로 전환
      clearPartnerGuestSession();
    }
    return true;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const signup = async (payload: SignupPayload): Promise<SignupResult> => {
  try {
    const { data } = await api().post<ApiResponse<number>>(
      '/v1/auth/register',
      payload,
    );
 
    return {
      success: true,
      status: 201,
      code: data?.resultCode ?? 'SUCCESS',
      message: data?.message ?? '회원가입 신청이 완료되었습니다.',
      data,
    };
  } catch (error: any) {
    const status: number = error?.response?.status ?? 0;
    const serverData = error?.response?.data;
 
    // 409 → 중복 username
    if (status === 409) {
      return {
        success: false,
        status,
        code: serverData?.resultCode ?? 'DUPLICATE_USERNAME',
        message: '이미 존재하는 아이디입니다.',
      };
    }
 
    // 400 → 유효성 오류
    if (status === 400) {
      return {
        success: false,
        status,
        code: serverData?.resultCode ?? 'BAD_REQUEST',
        message: serverData?.message ?? '입력 정보를 확인해주세요.',
      };
    }
 
    // 그 외 서버 오류 / 네트워크 오류
    return {
      success: false,
      status,
      code: serverData?.resultCode ?? 'UNKNOWN',
      message:
        serverData?.message ??
        '회원가입 처리 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
    };
  }
};